document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('mouseenter', function(e) {
    if (e.target.nodeType !== 1) return;
    const tooltip = e.target.closest('.product-tooltip');
    if (tooltip) {
      const productItem = tooltip.querySelector('.product-item');
      if (productItem) {
        const productId = productItem.getAttribute('data-product-id');
        
        // Pour shopable-image
        const shopableHotspot = document.querySelector('shopable-image.hotspot[data-product-id="' + productId + '"]');
        if (shopableHotspot) {
          shopableHotspot.classList.add('active');
        }
        
        // Pour bundle-products
        document.querySelectorAll('.bundle-products-link').forEach(function(link) {
          const template = link.querySelector('template');
          if (template) {
            const templateContent = template.content;
            const templateProductItem = templateContent.querySelector('.product-item[data-product-id="' + productId + '"]');
            if (templateProductItem) {
              const hotspot = link.querySelector('.hotspot');
              if (hotspot) {
                hotspot.classList.add('active');
              }
            }
          }
        });
      }
    }
  }, true);

  document.addEventListener('mouseleave', function(e) {
    if (e.target.nodeType !== 1) return;
    const tooltip = e.target.closest('.product-tooltip');
    if (tooltip) {
      const productItem = tooltip.querySelector('.product-item');
      if (productItem) {
        const productId = productItem.getAttribute('data-product-id');
        
        // Pour shopable-image
        const shopableHotspot = document.querySelector('shopable-image.hotspot[data-product-id="' + productId + '"]');
        if (shopableHotspot) {
          shopableHotspot.classList.remove('active');
        }
        
        // Pour bundle-products
        document.querySelectorAll('.bundle-products-link').forEach(function(link) {
          const template = link.querySelector('template');
          if (template) {
            const templateContent = template.content;
            const templateProductItem = templateContent.querySelector('.product-item[data-product-id="' + productId + '"]');
            if (templateProductItem) {
              const hotspot = link.querySelector('.hotspot');
              if (hotspot) {
                hotspot.classList.remove('active');
              }
            }
          }
        });
      }
    }
  }, true);
});